import axios from 'axios';
import { handleAxiosError } from 'core/notifications';
import map from 'lodash/map';

import getSelectOptions from './getSelectOptions';

export default async (searchValue) => {
  const url =
    '/api/admin/permissions/groups_and_admins?' +
    `reject=users${!searchValue ? '&limit=5' : ''}&search_query=${searchValue}`;

  try {
    const { data } = await axios.get(url);
    const transformedData = map(data.data, (user) => ({
      name: user.name,
      avatar: user.avatar_path,
      code: user.code,
      id: user.id,
      membersCount: user.metadata.number_of_members || null,
      eligibleMembers: user.metadata.eligible_members || null,
      type: user.type,
    }));
    return getSelectOptions(transformedData);
  } catch (error) {
    handleAxiosError(error);
  }
};
